<p-table [value]="cookies()" [tableStyle]="{width: '100%'}" class="hidden-sm-down">
  <ng-template pTemplate="header">
    <tr>
      <th scope="col" class="text-left font-normal bg-primary-light">
        {{ 'CookieConsent.Table.Name' | translate }}
      </th>
      <th scope="col" class="text-right font-normal bg-primary-light">
        {{ 'CookieConsent.Table.Provider' | translate }}
      </th>
      <th scope="col" class="text-right font-normal bg-primary-light">
        {{ 'CookieConsent.Table.Runtime' | translate }}
      </th>
      <th scope="col" class="text-left font-normal bg-primary-light">
        {{ 'CookieConsent.Table.Purpose' | translate }}
      </th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-cookie>
    <tr>
      <td class="text-left">{{ cookie.name }}</td>
      <td class="text-right">{{ cookie.provider }}</td>
      <td class="text-right">{{ cookie.runtime | translate }}</td>
      <td class="text-left">{{ cookie.purpose | translate }}</td>
    </tr>
  </ng-template>
</p-table>

@for (cookie of cookies(); track cookie) {
<div class="hidden-md-up mt-4">
  <div class="grid">
    <div class="col-4">
      <strong>{{ 'CookieConsent.Table.Name' | translate }}: </strong>
    </div>
    <div class="col-8">
      <p class="m-0">{{ cookie.name }}</p>
    </div>
  </div>

  <p-divider />

  <div class="grid">
    <div class="col-4">
      <strong>{{ 'CookieConsent.Table.Provider' | translate }}: </strong>
    </div>
    <div class="col-8">
      <p class="m-0">{{ cookie.provider }}</p>
    </div>
  </div>

  <p-divider />

  <div class="grid">
    <div class="col-4">
      <strong>{{ 'CookieConsent.Table.Runtime' | translate }}: </strong>
    </div>
    <div class="col-8">
      <p class="m-0">{{ cookie.runtime | translate }}</p>
    </div>
  </div>

  <p-divider />

  <div class="grid">
    <div class="col-4">
      <strong>{{ 'CookieConsent.Table.Purpose' | translate }}: </strong>
    </div>
    <div class="col-8">
      <p class="m-0">{{ cookie.purpose | translate }}</p>
    </div>
  </div>

  <p-divider />
</div>
}
